import {ConsumptionPageLoader} from "../ConsumptionPageLoader.tsx";
import {useHostResolvedSlug} from "../useHostResolvedSlug.ts";
import {CheckDrilldown} from "./CheckDrilldown.tsx";

// Host-mode drilldown entry (route "/c/:serviceId"). On a custom domain the slug is not in
// the URL, so resolve it from the host and pass it to CheckDrilldown; the serviceId comes
// from the path param.
export const HostCheckDrilldown = () => {
  const {slug, loading} = useHostResolvedSlug();

  if (loading) {
    return <ConsumptionPageLoader />;
  }

  return <CheckDrilldown slug={slug} hostMode />;
};
